// import React, { useState, useEffect } from 'react';
// import { Phone, Shield, Mail, Edit2, Check, X, User, Key, Database, AlertCircle } from 'lucide-react';
// import { database, ref, get, set, update } from '../../firebase';

// const AccountDetails = () => {
//   const [accountData, setAccountData] = useState({
//     mobile: '',
//     role: 'admin',
//     email: '',
//     userId: 'admin',
//     otp: '',
//     password: 'Admin@123'
//   });
  
//   const [isEditing, setIsEditing] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isFetching, setIsFetching] = useState(true);
//   const [saveStatus, setSaveStatus] = useState({ type: '', message: '' });
//   const [adminKey, setAdminKey] = useState('');

//   useEffect(() => {
//     fetchAdminData();
//   }, []);

//   const fetchAdminData = async () => {
//     try {
//       setIsFetching(true);
      
//       const adminRef = ref(database, 'admin');
//       const snapshot = await get(adminRef);
      
//       if (snapshot.exists()) {
//         const data = snapshot.val();
        
//         let foundAdmin = null;
//         let foundKey = '';
        
//         for (const [key, value] of Object.entries(data)) {
//           if (key === 'loginLogs' || key === 'adminLoginLogs') continue;
          
//           if (value.userId === 'admin' || value.role === 'admin') {
//             foundAdmin = value;
//             foundKey = key;
//             break;
//           }
//         }
        
//         if (foundAdmin) {
//           setAccountData({
//             mobile: foundAdmin.mobile || '',
//             role: foundAdmin.role || 'admin',
//             email: foundAdmin.email || '',
//             userId: foundAdmin.userId || 'admin',
//             otp: foundAdmin.otp || '',
//             password: foundAdmin.password || 'Admin@123'
//           });
//           setAdminKey(foundKey);
//         } else {
//           await createDefaultAdmin();
//         }
//       } else {
//         await createDefaultAdmin();
//       }
//     } catch (error) {
//       console.error('Error fetching admin data:', error);
//       setSaveStatus({ type: 'error', message: 'Failed to load admin data' });
//     } finally {
//       setIsFetching(false);
//     }
//   };

//   const createDefaultAdmin = async () => {
//     const defaultAdmin = {
//       userId: 'admin',
//       password: 'Admin@123',
//       role: 'admin',
//       email: 'admin@aurumexchange.com',
//       mobile: '',
//       otp: '',
//       createdAt: new Date().toISOString(),
//       updatedAt: new Date().toISOString()
//     };

//     try {
//       const adminRef = ref(database, 'admin/adminAccount');
//       await set(adminRef, defaultAdmin);
      
//       setAccountData(defaultAdmin);
//       setAdminKey('adminAccount');
//       console.log('✅ Default admin created in admin.json');
//     } catch (error) {
//       console.error('Error creating admin:', error);
//     }
//   };

//   const handleEdit = () => {
//     setIsEditing(true);
//     setSaveStatus({ type: '', message: '' });
//   };

//   const handleSave = async () => {
//     try {
//       setIsLoading(true);
//       setSaveStatus({ type: 'loading', message: 'Saving admin details...' });

//       if (!adminKey) {
//         throw new Error('Admin key not found');
//       }

//       const adminRef = ref(database, `admin/${adminKey}`);
//       const snapshot = await get(adminRef);
      
//       if (!snapshot.exists()) {
//         throw new Error('Admin account not found');
//       }

//       const currentData = snapshot.val();
      
//       const updatedData = {
//         ...currentData,
//         mobile: accountData.mobile,
//         email: accountData.email,
//         otp: accountData.otp,
//         updatedAt: new Date().toISOString()
//       };

//       await set(adminRef, updatedData);
      
//       setIsEditing(false);
//       setSaveStatus({ 
//         type: 'success', 
//         message: '✅ Admin details updated successfully!' 
//       });
      
//       setTimeout(() => {
//         fetchAdminData();
//         setSaveStatus({ type: '', message: '' });
//       }, 2000);
      
//     } catch (error) {
//       console.error('Error saving admin data:', error);
//       setSaveStatus({ 
//         type: 'error', 
//         message: `❌ Failed to save: ${error.message}` 
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     fetchAdminData();
//     setIsEditing(false);
//     setSaveStatus({ type: '', message: '' });
//   };

//   if (isFetching) {
//     return (
//       <div className="flex items-center justify-center h-96">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
//           <div className="text-silver font-heading">Loading admin details...</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-custom">
//       <div className="mb-8">
//         <h1 className="text-3xl font-bold text-foreground mb-2 font-heading">Admin Account Details</h1>
//         <p className="text-silver font-body">Administrator Information Management</p>
//       </div>

//       {saveStatus.message && (
//         <div className={`mb-6 p-4 rounded-lg border ${
//           saveStatus.type === 'success' ? 'bg-green-900/30 border-green-600/30' : 
//           saveStatus.type === 'error' ? 'bg-red-900/30 border-red-600/30' : 
//           'bg-blue-900/30 border-blue-600/30'
//         } card-glow`}>
//           <div className="flex items-center">
//             {saveStatus.type === 'success' && <Check className="h-5 w-5 text-green-400 mr-2" />}
//             {saveStatus.type === 'error' && <AlertCircle className="h-5 w-5 text-red-400 mr-2" />}
//             {saveStatus.type === 'loading' && (
//               <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-400 mr-2"></div>
//             )}
//             <span className={`${
//               saveStatus.type === 'success' ? 'text-green-300' : 
//               saveStatus.type === 'error' ? 'text-red-300' : 'text-blue-300'
//             } font-body`}>
//               {saveStatus.message}
//             </span>
//           </div>
//           {saveStatus.type === 'error' && adminKey && (
//             <p className="text-xs text-red-400 mt-2 font-body">
//               Admin Key: {adminKey}
//             </p>
//           )}
//         </div>
//       )}

//       <div className="card-glow p-8 mb-8">
//         <div className="flex justify-between items-center mb-6">
//           <div>
//             <h2 className="text-xl font-semibold text-foreground font-heading">Edit Admin Details</h2>
//             <p className="text-silver mt-1 font-body">Update administrator contact information</p>
//           </div>
//           <div className="flex gap-3">
//             {isEditing ? (
//               <>
//                 <button 
//                   onClick={handleCancel} 
//                   className="flex items-center px-4 py-2 bg-secondary hover:bg-secondary/80 text-foreground rounded-xl transition-colors border border-border font-medium font-body"
//                 >
//                   <X className="h-4 w-4 mr-2" /> Cancel
//                 </button>
//                 <button 
//                   onClick={handleSave} 
//                   disabled={isLoading}
//                   className="btn-electric flex items-center px-4 py-2 rounded-xl font-medium disabled:opacity-50 disabled:cursor-not-allowed font-body"
//                 >
//                   {isLoading ? (
//                     <>
//                       <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                       Saving...
//                     </>
//                   ) : (
//                     <>
//                       <Check className="h-4 w-4 mr-2" /> Save Changes
//                     </>
//                   )}
//                 </button>
//               </>
//             ) : (
//               <button 
//                 onClick={handleEdit} 
//                 className="btn-electric flex items-center px-4 py-2 rounded-xl font-medium font-body"
//               >
//                 <Edit2 className="h-4 w-4 mr-2" /> Edit Details
//               </button>
//             )}
//           </div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           <div className="space-y-2">
//             <label className="text-sm font-medium text-silver font-heading">Mobile Number</label>
//             {isEditing ? (
//               <input
//                 type="text"
//                 value={accountData.mobile}
//                 onChange={(e) => setAccountData({...accountData, mobile: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:border-primary transition-colors font-body"
//                 placeholder="Enter mobile number"
//               />
//             ) : (
//               <div className="px-4 py-3 bg-secondary/50 border border-border rounded-lg text-foreground font-body">
//                 {accountData.mobile || 'Not set'}
//               </div>
//             )}
//           </div>

//           <div className="space-y-2">
//             <label className="text-sm font-medium text-silver font-heading">Email Address</label>
//             {isEditing ? (
//               <input
//                 type="email"
//                 value={accountData.email}
//                 onChange={(e) => setAccountData({...accountData, email: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:border-primary transition-colors font-body"
//                 placeholder="Enter email address"
//               />
//             ) : (
//               <div className="px-4 py-3 bg-secondary/50 border border-border rounded-lg text-foreground font-body">
//                 {accountData.email || 'Not set'}
//               </div>
//             )}
//           </div>

//           <div className="space-y-2">
//             <label className="text-sm font-medium text-silver font-heading">OTP Code</label>
//             {isEditing ? (
//               <input
//                 type="text"
//                 value={accountData.otp}
//                 onChange={(e) => setAccountData({...accountData, otp: e.target.value})}
//                 className="w-full px-4 py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:border-primary transition-colors font-body"
//                 placeholder="Enter OTP code"
//               />
//             ) : (
//               <div className="px-4 py-3 bg-secondary/50 border border-border rounded-lg text-foreground font-body">
//                 {accountData.otp || 'Not set'}
//               </div>
//             )}
//           </div>

//           <div className="space-y-2">
//             <label className="text-sm font-medium text-silver font-heading">User ID</label>
//             <div className="px-4 py-3 bg-secondary border border-border rounded-lg text-foreground flex items-center">
//               <Shield className="h-5 w-5 text-primary mr-3" />
//               <span className="font-medium font-body">{accountData.userId}</span>
//             </div>
//           </div>
//         </div>
//       </div>

     
//     </div>
//   );
// };

// export default AccountDetails;



import React, { useState, useEffect } from 'react';
import { Phone, Shield, Mail, Edit2, Check, X, User, Key, Database, AlertCircle, Calendar } from 'lucide-react';
import { database, ref, get, set, update } from '../../firebase';

const AccountDetails = () => {
  const [accountData, setAccountData] = useState({
    mobile: '',
    role: 'admin',
    email: '',
    userId: 'admin',
    otp: '',
    password: 'Admin@123'
  });
  
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [saveStatus, setSaveStatus] = useState({ type: '', message: '' });
  const [dateKey, setDateKey] = useState('');

  useEffect(() => {
    fetchAdminData();
  }, []);

  const fetchAdminData = async () => {
    try {
      setIsFetching(true);
      
      // First, get the current date to form the key (YYYY-MM-DD format)
      const currentDate = new Date().toISOString().split('T')[0]; // e.g., "2026-02-06"
      setDateKey(currentDate);
      
      // Check if admin data exists in the date-based structure
      const dateRef = ref(database, `admin/${currentDate}`);
      const snapshot = await get(dateRef);
      
      if (snapshot.exists()) {
        const dateData = snapshot.val();
        
        // Look for adminAccount inside the date node
        if (dateData.adminAccount) {
          const adminData = dateData.adminAccount;
          
          setAccountData({
            mobile: adminData.mobile || '',
            role: adminData.role || 'admin',
            email: adminData.email || '',
            userId: adminData.userId || 'admin',
            otp: adminData.otp || '',
            password: adminData.password || 'Admin@123'
          });
          
          console.log('✅ Admin account data loaded from date node:', adminData);
        } else {
          // Check in the root admin node as fallback
          await checkRootAdmin();
        }
      } else {
        // If date node doesn't exist, check root admin
        await checkRootAdmin();
      }
    } catch (error) {
      console.error('Error fetching admin data:', error);
      setSaveStatus({ type: 'error', message: 'Failed to load admin data' });
    } finally {
      setIsFetching(false);
    }
  };

  const checkRootAdmin = async () => {
    try {
      // Check if adminAccount exists in root admin node (for backward compatibility)
      const rootAdminRef = ref(database, 'admin/adminAccount');
      const snapshot = await get(rootAdminRef);
      
      if (snapshot.exists()) {
        const adminData = snapshot.val();
        
        setAccountData({
          mobile: adminData.mobile || '',
          role: adminData.role || 'admin',
          email: adminData.email || '',
          userId: adminData.userId || 'admin',
          otp: adminData.otp || '',
          password: adminData.password || 'Admin@123'
        });
        
        console.log('✅ Admin account data loaded from root node');
        
        // Migrate to date-based structure
        await migrateToDateStructure(adminData);
      } else {
        // Create new admin in date-based structure
        await createDefaultAdmin();
      }
    } catch (error) {
      console.error('Error checking root admin:', error);
      await createDefaultAdmin();
    }
  };

  const migrateToDateStructure = async (adminData) => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const dateRef = ref(database, `admin/${currentDate}/adminAccount`);
      
      const updatedData = {
        ...adminData,
        migratedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      await set(dateRef, updatedData);
      console.log('✅ Admin data migrated to date-based structure');
    } catch (error) {
      console.error('Error migrating data:', error);
    }
  };

  const createDefaultAdmin = async () => {
    const defaultAdmin = {
      userId: 'admin',
      password: 'Admin@123',
      role: 'admin',
      email: 'admin@aurumexchange.com',
      mobile: '',
      otp: '',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const dateRef = ref(database, `admin/${currentDate}/adminAccount`);
      await set(dateRef, defaultAdmin);
      
      setAccountData(defaultAdmin);
      console.log('✅ Default admin created in date-based structure');
    } catch (error) {
      console.error('Error creating admin:', error);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    setSaveStatus({ type: '', message: '' });
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      setSaveStatus({ type: 'loading', message: 'Saving admin details...' });

      // Get current date for the date-based structure
      const currentDate = new Date().toISOString().split('T')[0];
      
      // Reference to the adminAccount inside the date node
      const dateAdminRef = ref(database, `admin/${currentDate}/adminAccount`);
      const snapshot = await get(dateAdminRef);
      
      // Get current data or create new if doesn't exist
      const currentData = snapshot.exists() ? snapshot.val() : {};
      
      // Prepare updated data
      const updatedData = {
        ...currentData,
        userId: accountData.userId || 'admin',
        role: accountData.role || 'admin',
        password: accountData.password || 'Admin@123',
        mobile: accountData.mobile,
        email: accountData.email,
        otp: accountData.otp,
        updatedAt: new Date().toISOString()
      };

      // Add createdAt if it doesn't exist (for new entries)
      if (!updatedData.createdAt) {
        updatedData.createdAt = new Date().toISOString();
      }

      // Save to date-based structure: admin/{currentDate}/adminAccount
      await set(dateAdminRef, updatedData);
      
      setIsEditing(false);
      setSaveStatus({ 
        type: 'success', 
        message: '✅ Admin details updated successfully!' 
      });
      
      // Refresh data after successful save
      setTimeout(() => {
        fetchAdminData();
        setSaveStatus({ type: '', message: '' });
      }, 2000);
      
    } catch (error) {
      console.error('Error saving admin data:', error);
      setSaveStatus({ 
        type: 'error', 
        message: `❌ Failed to save: ${error.message}` 
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    fetchAdminData();
    setIsEditing(false);
    setSaveStatus({ type: '', message: '' });
  };

  if (isFetching) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
          <div className="text-silver font-heading">Loading admin details...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-custom">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-foreground mb-2 font-heading">Admin Account Details</h1>
        <p className="text-silver font-body">Administrator Information Management</p>
      </div>

      {saveStatus.message && (
        <div className={`mb-6 p-4 rounded-lg border ${
          saveStatus.type === 'success' ? 'bg-green-900/30 border-green-600/30' : 
          saveStatus.type === 'error' ? 'bg-red-900/30 border-red-600/30' : 
          'bg-blue-900/30 border-blue-600/30'
        } card-glow`}>
          <div className="flex items-center">
            {saveStatus.type === 'success' && <Check className="h-5 w-5 text-green-400 mr-2" />}
            {saveStatus.type === 'error' && <AlertCircle className="h-5 w-5 text-red-400 mr-2" />}
            {saveStatus.type === 'loading' && (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-400 mr-2"></div>
            )}
            <span className={`${
              saveStatus.type === 'success' ? 'text-green-300' : 
              saveStatus.type === 'error' ? 'text-red-300' : 'text-blue-300'
            } font-body`}>
              {saveStatus.message}
            </span>
          </div>
          {saveStatus.type === 'error' && dateKey && (
            <p className="text-xs text-red-400 mt-2 font-body">
              Date Path: admin/{dateKey}/adminAccount
            </p>
          )}
        </div>
      )}

      <div className="card-glow p-8 mb-8">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-xl font-semibold text-foreground font-heading">Edit Admin Details</h2>
            <p className="text-silver mt-1 font-body">Update administrator contact information</p>
          </div>
          <div className="flex gap-3">
            {isEditing ? (
              <>
                <button 
                  onClick={handleCancel} 
                  className="flex items-center px-4 py-2 bg-secondary hover:bg-secondary/80 text-foreground rounded-xl transition-colors border border-border font-medium font-body"
                >
                  <X className="h-4 w-4 mr-2" /> Cancel
                </button>
                <button 
                  onClick={handleSave} 
                  disabled={isLoading}
                  className="btn-electric flex items-center px-4 py-2 rounded-xl font-medium disabled:opacity-50 disabled:cursor-not-allowed font-body"
                >
                  {isLoading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Saving...
                    </>
                  ) : (
                    <>
                      <Check className="h-4 w-4 mr-2" /> Save Changes
                    </>
                  )}
                </button>
              </>
            ) : (
              <button 
                onClick={handleEdit} 
                className="btn-electric flex items-center px-4 py-2 rounded-xl font-medium font-body"
              >
                <Edit2 className="h-4 w-4 mr-2" /> Edit Details
              </button>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="text-sm font-medium text-silver font-heading">Mobile Number</label>
            {isEditing ? (
              <input
                type="text"
                value={accountData.mobile}
                onChange={(e) => setAccountData({...accountData, mobile: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:border-primary transition-colors font-body"
                placeholder="Enter mobile number"
              />
            ) : (
              <div className="px-4 py-3 bg-secondary/50 border border-border rounded-lg text-foreground font-body">
                {accountData.mobile || 'Not set'}
              </div>
            )}
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-silver font-heading">Email Address</label>
            {isEditing ? (
              <input
                type="email"
                value={accountData.email}
                onChange={(e) => setAccountData({...accountData, email: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:border-primary transition-colors font-body"
                placeholder="Enter email address"
              />
            ) : (
              <div className="px-4 py-3 bg-secondary/50 border border-border rounded-lg text-foreground font-body">
                {accountData.email || 'Not set'}
              </div>
            )}
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-silver font-heading">OTP Code</label>
            {isEditing ? (
              <input
                type="text"
                value={accountData.otp}
                onChange={(e) => setAccountData({...accountData, otp: e.target.value})}
                className="w-full px-4 py-3 bg-secondary border border-border rounded-lg text-foreground focus:outline-none focus:border-primary transition-colors font-body"
                placeholder="Enter OTP code"
              />
            ) : (
              <div className="px-4 py-3 bg-secondary/50 border border-border rounded-lg text-foreground font-body">
                {accountData.otp || 'Not set'}
              </div>
            )}
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-silver font-heading">User ID</label>
            <div className="px-4 py-3 bg-secondary border border-border rounded-lg text-foreground flex items-center">
              <Shield className="h-5 w-5 text-primary mr-3" />
              <span className="font-medium font-body">{accountData.userId}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="card-glow p-6">
        <div className="flex items-center mb-4">
          <Calendar className="h-6 w-6 text-primary mr-3" />
          <h3 className="text-lg font-semibold text-foreground font-heading">Database Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 bg-secondary/50 border border-border rounded-lg">
            <div className="text-sm text-silver font-heading">Date-based Storage</div>
            <div className="text-foreground font-medium font-body mt-1">admin/{dateKey}/adminAccount</div>
          </div>
          <div className="p-4 bg-secondary/50 border border-border rounded-lg">
            <div className="text-sm text-silver font-heading">Current Date</div>
            <div className="text-foreground font-medium font-body mt-1">{dateKey || new Date().toISOString().split('T')[0]}</div>
          </div>
        </div>
        <div className="mt-4 p-4 bg-secondary/30 border border-border rounded-lg">
          <div className="text-sm text-silver font-heading">Note</div>
          <div className="text-foreground text-sm font-body mt-1">
            Admin details are now saved in date-based JSON structure: admin/YYYY-MM-DD/adminAccount
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;